import meta from "../../assets/meta.jpeg";
import graduation from "../../assets/graduation.jpeg";
import designer from "../../assets/verified_designer.jpeg";
import ui from "../../assets/ui_designer.png";
import ux from "../../assets/ux_designer.png";
import frontend_1 from "../../assets/frontend-1.jpg";
import interaction_design_1 from "../../assets/interaction_design-1.png";
import leading_innovation from "../../assets/leading_innovation.png";

const Verification = () => {
  return (
    <section
      className="w-screen py-12 px-6 md:pt-24 md:pb-12 md:px-16"
      id="accreditations"
    >
      <div>
        <h2 className="text-2xl md:text-4xl text-left md:text-center mb-8 md:mb-12">
          Accreditations
        </h2>
        <div className="max-w-5xl mx-auto space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-6">
            {educationData.map((item, index) => (
              <EducationCard
                key={index}
                title={item.title}
                degree={item.degree}
                years={item.years}
                image={item.image}
                link={item.link}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Verification;

const educationData = [
  {
    title: "Bachelor in Software Engineering",
    degree: "Kirirom Institute of Technology",
    years: "2022",
    image: graduation,
  },
  {
    title: "Meta Front-End Developer",
    degree: "Coursera",
    years: "2024",
    image: meta,
    link: "https://www.coursera.org/account/accomplishments/specialization/3QXZD7XATJFP",
  },
  {
    title: "Verified Designer Skill Test",
    degree: "Uxcel",
    years: "2022",
    image: designer,
    link: "https://app.uxcel.com/assessment-report/L8WK3VL5?utm_source=assessment-report",
  },
  {
    title: "Front-End Web Development",
    degree: "Udemy",
    years: "2020",
    image: frontend_1,
    link: "https://www.udemy.com/certificate/UC-0767f2bc-2891-4ff5-aa54-600e419e26b3/",
  },
  {
    title: "UX Designer",
    degree: "Uxcel",
    years: "2022",
    image: ux,
    link: "https://app.uxcel.com/certificates/0W7NX25E9GYH",
  },
  {
    title: "UI Designer",
    degree: "Uxcel",
    years: "2022",
    image: ui,
    link: "https://certificates.uxcel.com/Y85CPQV9KIUT",
  },
  {
    title: "Leading with Innovation",
    degree: "LinkedIn Learning",
    years: "2022",
    image: leading_innovation,
    link: "https://www.linkedin.com/learning/certificates/879a0f2f9e451a0d5ccf791e85de0a0c11313f6bd1275244be0ae792cba19186?trk=backfilled_certificate",
  },
  {
    title: "Interaction Design",
    degree: "LinkedIn Learning",
    years: "2022",
    image: interaction_design_1,
    link: "https://www.linkedin.com/learning/certificates/0c64fb6ce6fbca67903522e5cda098e5e9df0adc141528cd028336e5528d3cc5",
  },
];

const EducationCard = ({ title, degree, years, image, link }) => {
  const handleClick = () => {
    if (link) {
      window.open(link, "_blank"); // Opens the link in a new tab
      console.log(link);
    }
  };
  return (
    <div
      className="bg-white rounded-2xl overflow-hidden w-full max-w-sm cursor-pointer hover:shadow-lg transition-shadow duration-300 flex flex-col"
      onClick={handleClick}
    >
      <div className="w-full h-48 px-4 pt-4 rounded-lg">
        <img
          src={image}
          alt={title}
          className="size-full object-contain bg-center rounded-lg"
        />
      </div>
      <div className="flex flex-col flex-grow px-4 pb-4 pt-1">
        {/* Title with flex-grow to push the degree section down */}
        <h3 className="font-bold text-lg flex-grow">{title}</h3>

        {/* Degree and years section aligned at the bottom */}
        <div className="flex justify-between items-center mt-2">
          <p className="text-gray-600 text-base">{degree}</p>
          <span className="inline-flex items-center self-end rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-600 ring-1 ring-inset ring-blue-500/10">
            {years}
          </span>
        </div>
      </div>
    </div>
  );
};
